import React, { useEffect, useState } from 'react';
import '../assets/css/material-dashboard.css'
import './criarordemmodal.css'
import HomeLf from './HomeLf';
import { db, firebaseAuth } from '../utils/firebase-config';
import { onAuthStateChanged } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { collection, doc, getDocs, updateDoc } from 'firebase/firestore';
import Background from 'three/examples/jsm/renderers/common/Background.js';
import { Center } from '@react-three/drei';



import logo from '../assets/version2/logo.png';
import listicon from '../assets/version2/listicon.png';
import gridicon from '../assets/version2/gridicon.png';

import Rodape from './Rodape';

function OrdensDeServico(params) {

  const navigate = useNavigate();


  const [current, setCurrent] = useState('');
  const [dataA, setDataA] = useState([]);
  const [filtrados, setFiltrados] = useState([]);
  const [filtradosC, setFiltradosC] = useState([]);
  const [filtrados3, setFiltrados3] = useState([]);
  const [filtrados4, setFiltrados4] = useState([]);
  const [filtrados5, setFiltrados5] = useState([]);
  const [filtrados6, setFiltrados6] = useState([]);
  const [filtradosB, setFiltradosB] = useState([]);
  const [objetoTarget, setObjetoTarget] = useState();
  const [dataId, setDataId] = useState();
  const [nomeproj, setNomeproj] = useState('');
  const [solucao, setSolucao] = useState([]);
  const [objprojeto, setObjprojeto] = useState([]);
  const [corSim, setCorSim] = useState(true);
  const [andamento, setAndamento] = useState(false);

  const [dataMaster, setDataMaster] = useState([]);


    const [mapeA, setMapeA] = useState([1]);
    const [hide, setHide] = useState('none');
    const [hide2, setHide2] = useState('none');

var count01 = 0;
const queryParameters = new URLSearchParams(window.location.search)
const parametroId = queryParameters.get("prjid")


const [countMp, setCountMp] = useState(1);

const [dataPendencias, setDataPendencias] = useState([]);






async function master(params) {

      

  var objMaster = [];
  var objMaster2 = [];

   


  onAuthStateChanged(firebaseAuth, async (currentUser) => {
    if (currentUser) {
      var usuarioLogado = currentUser.email;
      setCurrent(usuarioLogado);
    };
  });


  await fetch('https://apilumera.shop/api/consultaOrdem', {
    method: 'POST',
    body: JSON.stringify({
      parametroId: parametroId,

    }),
    headers: {
      'Content-type': 'application/json; charset=UTF-8',
    },
  })
     .then((response) => response.json())
     .then((data) => {

        var criados = data;
     

        
        setFiltradosB(criados);
        setAndamento(criados.andamento);

         var tradd = [];
        tradd.push(criados.ordens);
        tradd = tradd[0];
        var masterTrad = [];
        var masterTrad2 = [];

      for (let i = 0; i < Object.keys(criados.ordens).length; i++) {
    //      console.log(tradd[Object.keys(criados.ordens)[i]]);
            masterTrad.push(tradd[Object.keys(criados.ordens)[i]]);
              masterTrad2.push(tradd[Object.keys(criados.ordens)[i]]);
      }
             var filtrar = [];
             var filtrar3 = [];
             var filtrar4 = [];
             var filtrar5 = [];
             var filtrar6 = [];

               var colaborador = [];
          for (let i = 0; i < masterTrad2.length; i++) {
            if(masterTrad2[i].participantes.length > 0){
                colaborador.push(masterTrad2[i].participantes);
            }
          }
                  var tradeRemove = [];
                  var tradeRemove2 = [];
                 for (let i = 0; i < colaborador.length; i++) {
                
                  tradeRemove.push(colaborador[i][0]);
                  
                 }
                  
                 
             function removeDuplicatesWithSet2(arr) {
                 return [...new Set(arr)];
             }

           var uniqueArray2 = removeDuplicatesWithSet2(tradeRemove);

          

           for (let i = 0; i < uniqueArray2.length; i++) {
                       tradeRemove2.push([uniqueArray2[i]])
           }


         setSolucao(tradeRemove2);





        for (let i = 0; i < masterTrad.length; i++) {
          if(masterTrad[i].status == 'Pendente'){
            filtrar.push(masterTrad[i]);
          } else {
            filtrar3.push(masterTrad[i]);
          }
          
        }


           for (let i = 0; i < masterTrad.length; i++) {
          if(masterTrad[i].prioridade == 'alta'){
            filtrar4.push(masterTrad[i]);
          } else if(masterTrad[i].prioridade == 'media'){
            filtrar5.push(masterTrad[i]);
          } else {
             filtrar6.push(masterTrad[i]);
          }
          
        }



        
        console.log('MASTER MASTER', masterTrad);


        setDataA(masterTrad2);
        






      setFiltrados(masterTrad2);
      setFiltradosC(masterTrad2);
      setFiltrados3(filtrar3);
      setFiltrados4(filtrar4);
      setFiltrados5(filtrar5);
      setFiltrados6(filtrar6);











     })
     .catch((err) => {
        console.log(err.message);
     });























     await fetch('https://apilumera.shop/api/consultaprojeto', {
      method: 'POST',
      body: JSON.stringify({
        id: parametroId,
  
      }),
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
      },
    })
       .then((response) => response.json())
       .then((data) => {

          var projetoAtual = data;               
          setNomeproj(projetoAtual.nomeDoProjeto);
        setDataMaster(projetoAtual.colaboradores);
        setObjprojeto(projetoAtual);

     

  
       })
       .catch((err) => {
          console.log(err.message);
       });
  




























      












        



}


async function editar(params) {
  navigate(`/editar?projeto=${params}`);
}





async function dell(params) {


  await updateDoc(doc(db, 'clientes', `${firebaseAuth.currentUser.email}:projetos`), {
    [params]: {
        nomeDoProjeto: 'nd',
      

    }
  
  });
  navigate(0);
}






useEffect(()=> {
  master();
},[])











function enviarPost01() {


  function getObj(params) {

    for (let i = 0; i < dataMaster.length; i++) {
        if(dataMaster[i].split('###master')[3].replaceAll(' ', '') == params.replaceAll(' ', '')){
          return dataMaster[i];
        }
    }
}



var tradecolaboradores = [];
for (let i = 0; i < document.querySelectorAll('.colaboradores').length; i++) {
    tradecolaboradores.push(getObj(document.querySelectorAll('.colaboradores')[i].value.replaceAll(' ', '')))
  
}
  
  

  var emailsColaboradores = [];

  for (let i = 0; i < tradecolaboradores.length; i++) {
    emailsColaboradores.push(tradecolaboradores[i].split('###master')[0]);
    
  }

  var nomeDaPendencia = document.querySelector('.inputNormal').value;
  var prioridadependencia = document.querySelector('.prioridade').value;





   var ligadoNotif = false;

    
    for (let i = 0; i < objprojeto.emailsParticipantes.length; i++) {
      
        if(current.replaceAll(' ', '') == objprojeto.emailsParticipantes[i].replaceAll(' ', '')){
          ligadoNotif = true;
        }
    }





  

  fetch('https://apilumera.shop/api/criarordem', {
    method: 'POST',
    body: JSON.stringify({
      email: firebaseAuth.currentUser.email,
      parametroId: parametroId,
      ligadoNotif: ligadoNotif,
      ower: objprojeto.criador,
      nomeOrdem: nomeDaPendencia,
      participantes: tradecolaboradores,
      dataFinalizacao: '',
      emailsParticipantes: emailsColaboradores,
      prioridade: prioridadependencia,
      nomeProjeto: nomeproj,
      sobre: document.querySelector('textarea').value,
      dataexpiracao: document.querySelector('.dataexpiracao').value
    //  ordemPrioridade: ordemPrioridade
    }),
    headers: {
      'Content-type': 'application/json; charset=UTF-8',
    },
  })
     .then((response) => response.json())
     .then((data) => {
        window.location.reload();
     })
     .catch((err) => {
        window.location.reload();
     });

    
}

function finalizarProjeto() {
  
  fetch('https://apilumera.shop/api/finalizarprojeto', {
    method: 'POST',
    headers: {'Content-type': 'application/json; charset=UTF-8'},
    body: JSON.stringify({
       parametroId: parametroId,
    }),
  }) .then(()=> window.location.reload() )



}











var trad = [];

function mapear() {
            
  setCountMp(countMp + 1);

  for (let i = 0; i < countMp; i++) {
      trad.push(i);
      
  }
  trad.push(countMp);
  setMapeA(trad);
}









 function filtrar(params) {
        
var tradeobj3 = [];


if(document.querySelectorAll('.checkb')[0].checked){
for (let i = 0; i < dataA.length; i++) {
  if(dataA[i].status == 'Pendente') {
    tradeobj3.push(dataA[i]);
  }
}
}


if(document.querySelectorAll('.checkb')[1].checked){
for (let i = 0; i < dataA.length; i++) {
  if(dataA[i].status == 'Finalizado') {
    tradeobj3.push(dataA[i]);
  }
}
}



var count = [];

for (let i = 0; i < document.querySelectorAll('.checkpoint input').length; i++) {
  count.push(document.querySelectorAll('.checkpoint a')[i].innerText);  
}

count.map((data, index)=> {
  
  
if(document.querySelectorAll('.checkpoint input')[index].checked){
  for (let i = 0; i < dataA.length; i++) {
    if(dataA[i].participantes[0] != undefined && dataA[i].participantes.length > 0) {

   if(dataA[i].participantes[0].split('###master')[3].replaceAll(' ', '') == 
    data.replaceAll(' ', '')) {
    tradeobj3.push(dataA[i]);

  }
    }
  
  }
}

})






var count2 = [];

for (let i = 0; i < document.querySelectorAll('.checkpoint2 input').length; i++) {
  count2.push(document.querySelectorAll('.checkpoint2 a')[i].innerText);  
}

count2.map((data, index)=> {
  
  
if(document.querySelectorAll('.checkpoint2 input')[index].checked){
  for (let i = 0; i < dataA.length; i++) {
    if(dataA[i].participantes[0] != undefined && dataA[i].participantes.length > 0) {

   if(dataA[i].participantes[0].split('###master')[1].replaceAll(' ', '') == 
    data.replaceAll(' ', '')) {
    tradeobj3.push(dataA[i]);

  }
    }
  
  }
}




})






   function removeDuplicatesWithSet(arr) {
     return [...new Set(arr)];
   }

  var uniqueArray = removeDuplicatesWithSet(tradeobj3);






 setFiltrados(uniqueArray);






       }








       function limparFiltros() {
          window.location.reload();
       }














    return (
      <>
        <div>


<HomeLf/>



<div className="fixmargin"></div>


      
      <div  style={{backgroundColor: 'rgba(100,100,100,0.5)', width: '100%', height: '100%', position: 'absolute',
 display: hide2 ,justifyContent: 'center', alignItems: 'center', zIndex: '900'

}}>


<div style={{ width: '500px',borderRadius: '16px', backgroundColor: '#fff', paddingBottom: '30px'}}>
<div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '10px',
paddingLeft: '20px', paddingRight: '20px',
alignItems: 'center'

}}>
<div><img src={logo} style={{width: '120px'}}></img></div>
<div>    <i class="bi bi-x" style={{fontSize: '25px', cursor: 'pointer'}}
onClick={()=> setHide2('none')}
/>
</div>

</div>
<div>






 <div
      style={{
     
        height: "100%",
        width: "100%",
        borderRadius: 10
      }}
    >
    
      <div
        style={{
          padding: "30px 10px",
          display: "flex",
          justifyContent: "space-between",
          borderBottom: "1px solid #F3F4F6",
          margin: "0px 10px",
          fontFamily: "Archivo, serif",
          fontWeight: 500,
          fontSize: 16,
          color: "#171A1F"
        }}
      >
        Filtros{" "}
        <a style={{ fontSize: 14, fontWeight: 400, color: "#574A69", cursor: 'pointer' }}
        onClick={()=> {limparFiltros(); setHide2('none')}}
        >
          Limpar Tudo
        </a>
      </div>
      <div
        style={{
          padding: "30px 10px",
          display: "flex",
          flexFlow: "column",
          justifyContent: "space-between",
          borderBottom: "1px solid #F3F4F6",
          margin: "0px 10px",
          fontFamily: "Archivo, serif",
          fontWeight: 500,
          fontSize: 16,
          color: "#171A1F"
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <a>Status</a>{" "}
          <a style={{ fontSize: 14, fontWeight: 400, color: "#574A69" }}>
            <i style={{ color: "black" }} className="bi bi-chevron-down" />
          </a>
        </div>
        <div
          style={{
            marginTop: 15,
            fontFamily: "Inter, serif",
            fontSize: 14,
            fontWeight: 400,
            display: "flex",
            flexFlow: "row nowrap",
            alignItems: "center"
          }}
        >
          <input
            style={{ width: 14, height: 14, marginRight: 5 }}
            type="checkbox"
            onClick={()=> filtrar()}
            className="checkb"
          />{" "}
          <a>Pendente</a>
        </div>
        <div
          style={{
            marginTop: 5,
            fontFamily: "Inter, serif",
            fontSize: 14,
            fontWeight: 400,
            display: "flex",
            flexFlow: "row nowrap",
            alignItems: "center"
          }}
        >
          <input
            style={{ width: 14, height: 14, marginRight: 5 }}
            type="checkbox"
            className="checkb"
            onChange={()=> filtrar()}
          />{" "}
          <a>Concluído</a>
        </div>
      </div>
      <div
        style={{
          padding: "30px 10px",
          display: "flex",
          flexFlow: "column",
          justifyContent: "space-between",
          borderBottom: "1px solid #F3F4F6",
          margin: "0px 10px",
          fontFamily: "Archivo, serif",
          fontWeight: 500,
          fontSize: 16,
          color: "#171A1F"
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <a>Responsável pela Solução</a>{" "}
          <a style={{ fontSize: 14, fontWeight: 400, color: "#574A69" }}>
            <i style={{ color: "black" }} className="bi bi-chevron-down" />
          </a>
        </div>




 {solucao.map((data, index)=> {

          return <>
                  <div
          style={{
            marginTop: '8px',
            fontFamily: "Inter, serif",
            fontSize: 14,
            fontWeight: 400,
            display: "flex",
            flexFlow: "row nowrap",
            alignItems: "center"
          }}
        >
          <div className="checkpoint">
          <input
            style={{ width: 14, height: 14, marginRight: 5 }}
            type="checkbox"
            
            onChange={()=> filtrar()}
          />{" "}
          <a>{
              data[0].split('#master')[3]
          }</a>
          </div>
        </div>
          
          
          </>
        })}







      </div>
      <div
        style={{
          padding: "30px 10px",
          display: "flex",
          flexFlow: "column",
          justifyContent: "space-between",
          borderBottom: "1px solid #F3F4F6",
          margin: "0px 10px",
          fontFamily: "Archivo, serif",
          fontWeight: 500,
          fontSize: 16,
          color: "#171A1F"
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <a>Requisitante</a>{" "}
          <a style={{ fontSize: 14, fontWeight: 400, color: "#574A69" }}>
            <i style={{ color: "black" }} className="bi bi-chevron-down" />
          </a>
        </div>






 {solucao.map((data, index)=> {

          return <>
                  <div
          style={{
            marginTop: '8px',
            fontFamily: "Inter, serif",
            fontSize: 14,
            fontWeight: 400,
            display: "flex",
            flexFlow: "row nowrap",
            alignItems: "center"
          }}
        >
          <div className="checkpoint2">
          <input
            style={{ width: 14, height: 14, marginRight: 5 }}
            type="checkbox"
            
            onChange={()=> filtrar()}
          />{" "}
          <a>{
              data[0].split('#master')[1].replaceAll('##', '')
          }</a>
          </div>
        </div>
          
          
          </>
        })}








      </div>
    </div>







<div style={{display: 'flex', justifyContent: 'end', alignItems: 'center', width: '100%', padding: '0px 30px', marginTop: '28px'}}>
        <div
         style={{width: '120px', cursor: 'pointer', height: '35px', borderRadius: '10px',
           display: 'flex', justifyContent: 'center',
            alignItems: 'center', fontWeight: '600', color: '#fff', backgroundColor: '#985EAC'}}
          onClick={()=> setHide2('none')}
        >Aplicar</div>
</div>

</div>



























<div style={{display: 'none'}}>

<div className="row" style={{ width: '100%', padding: '0px 30px', height: '35px', marginTop: '15px'}}>
<div className="col-6" style={{borderRadius: '10px 0px 0px 10px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center', backgroundColor: '#985EAC', color: '#fff'}}>Novo Projeto</div>
<div className="col-6" style={{borderRadius: '0px 10px 10px 0px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center', backgroundColor: 'rgba(100,100,100,0.1)', color: 'black'}}>Colaboradores</div>
</div>



<div className="row" style={{ width: '100%', padding: '0px 30px', height: '35px', marginTop: '15px'}}>
<div className="col-7" style={{borderRadius: '10px 0px 0px 10px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center'}}>
    

<input style={{border: '1px solid #fff', backgroundColor: 'rgba(200,200,200, 0.2)', width: '100%', height: '35px', borderRadius: '10px', padding: '0px 14px'}} placeholder="Email do colaborador"></input>
</div>
<div className="col-5" style={{borderRadius: '0px 10px 10px 0px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center', color: 'black'}}>
    <select style={{width: '100%', height: '35px', borderRadius: '10px'}}>
    <option value="Administrador"  style={{border: 'none'}}>Administrador</option>
  <option value="Gerente">Gerente</option>
  <option value="Engenheiro">Engenheiro</option>
  <option value="Prestador de serviços">Prestador de serviços</option>
    </select>

</div>
</div>






</div>






</div>

</div>










<div style={{backgroundColor: 'rgba(100,100,100,0.5)', width: '100%', height: `${document.documentElement.scrollHeight}px`, position: 'absolute',
 display: hide ,justifyContent: 'center', alignItems: 'center'

}}>


<div style={{ width: '500px',borderRadius: '16px', position: 'absolute', top: '10px', backgroundColor: '#fff', paddingBottom: '30px'}}>
<div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '10px',
paddingLeft: '20px', paddingRight: '20px',
alignItems: 'center'

}}>
<div><img src={logo} style={{width: '120px'}}></img></div>
<div>    <i class="bi bi-x" style={{fontSize: '25px', cursor: 'pointer'}}
onClick={()=> setHide('none')}
/>
</div>

</div>
<div>

<div className="row" style={{ width: '100%', padding: '0px 30px', height: '35px', marginTop: '15px'}}>
<div className="col-12" style={{borderRadius: '10px 10px 10px 10px', display: 'flex', fontSize: '16px', justifyContent: 'center', alignItems: 'center', backgroundColor: 'rgba(100, 100, 100, 0.02)', color: 'rgb(90, 90, 90)', fontWeight: 'bold'}}>Nova Pendência</div>
</div>

<div style={{padding: '0px 30px', marginTop: '30px'}}>
<div style={{fontWeight: 'bold', marginBottom: '2px'}}>Nome da pendência</div>
<div className="dastasColaboradores" style={{display: 'flex', marginBottom: '12px', flexFlow: 'row wrap', gap: '10px', marginTop: '10px'}}>
<input className='inputNormal' style={{padding: '5px 5px', borderRadius: '5px', border: 'solid 1px rgb(100, 100, 100)'}} placeholder='Nome da pendência'></input>
</div>
<div style={{fontWeight: 'bold', marginBottom: '12px'}}>Colaboradores</div>
<div className="dastasColaboradores" style={{display: 'flex', flexFlow: 'row wrap', gap: '10px', marginTop: '10px'}}>

{mapeA.map((data, index)=> {
return <>



<select className="colaboradores" style={{border: '1px solid #fff', backgroundColor: 'rgba(200,200,200, 0.2)', height: '35px', borderRadius: '10px', padding: '0px 14px'}}
>
  {dataMaster.map((data, index)=> {
    return <>
    
      <option value={data.split('###master')[3]}>{data.split('###master')[3]}</option>
    
    </>


  })}

</select>





</>
})}
<div>
  <i class="bi bi-plus"
   style={{fontSize: '30px', cursor: 'pointer',
    lineHeight: '15px', color: 'rgb(6, 129, 6)'}}
    onClick={()=> mapear()}
    ></i>
    </div>

</div>


<div style={{fontWeight: 'bold', marginBottom: '12px', marginTop: '15px'}}>Prioridade</div>
<select className="prioridade" style={{border: '1px solid #fff', backgroundColor: 'rgba(200,200,200, 0.2)', height: '35px', borderRadius: '10px', padding: '0px 14px'}}
>

<option value="baixa">Baixa</option>
<option value="media">Média</option>
<option value="alta">Alta</option>

</select>


<div style={{fontWeight: 'bold', marginBottom: '12px', marginTop: '15px'}}>Detalhes</div>


<textarea id="w3review" name="w3review" rows="4" cols="50" style={{padding: '10px'}} placeholder='Descreva como a pendência deve ser resolvida'/>

<div style={{fontWeight: 'bold', marginBottom: '12px', marginTop: '15px'}}>Data de expiração</div>



<input type="date" className="dataexpiracao" name="birthday"></input>





</div>



<div style={{display: 'flex', justifyContent: 'end', alignItems: 'center', width: '100%', padding: '0px 30px', marginTop: '28px'}}>
        <div
         style={{width: '150px', height: '35px',
           borderRadius: '10px', display: 'flex',
            justifyContent: 'center', alignItems: 'center',
             fontWeight: '600', color: '#fff', 
             backgroundColor: '#985EAC', cursor: 'pointer'}}
          onClick={()=> enviarPost01()}
        >Criar Pendência</div>
</div>

</div>



<div style={{display: 'none'}}>

<div className="row" style={{ width: '100%', padding: '0px 30px', height: '35px', marginTop: '15px'}}>
<div className="col-6" style={{borderRadius: '10px 0px 0px 10px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center', backgroundColor: '#985EAC', color: '#fff'}}>Novo Projeto</div>
<div className="col-6" style={{borderRadius: '0px 10px 10px 0px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center', backgroundColor: 'rgba(100,100,100,0.1)', color: 'black'}}>Colaboradores</div>
</div>



<div className="row" style={{ width: '100%', padding: '0px 30px', height: '35px', marginTop: '15px'}}>
<div className="col-7" style={{borderRadius: '10px 0px 0px 10px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center'}}>
    

<input style={{border: '1px solid #fff', backgroundColor: 'rgba(200,200,200, 0.2)', width: '100%', height: '35px', borderRadius: '10px', padding: '0px 14px'}} placeholder="Email do colaborador"></input>
</div>
<div className="col-5" style={{borderRadius: '0px 10px 10px 0px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center', color: 'black'}}>
    <select style={{width: '100%', height: '35px', borderRadius: '10px'}}>
    <option value="Administrador"  style={{border: 'none'}}>Administrador</option>
  <option value="Gerente">Gerente</option>
  <option value="Engenheiro">Engenheiro</option>
  <option value="Prestador de serviços">Prestador de serviços</option>
    </select>

</div>
</div>






</div>






</div>

</div>
      











<div
  className="col-12"
  style={{
    display: "flex",
    flexFlow: "row nowrap",
    justifyContent: "center",
    marginTop: 50,
    paddingRight: 20
  }}
>
  <div className="col-3 responsivefiltro" style={{ padding: "0px 20px" }}>
    <div
      style={{
        border: "1px solid #DEE1E6",
        height: "100%",
        width: "100%",
        borderRadius: 10
      }}
    >
      <div
        style={{
          padding: "30px 0px",
          display: "flex",
          justifyContent: "center",
          borderBottom: "1px solid #F3F4F6",
          margin: "0px 10px"
        }}
      >

       {andamento ? 
        <div>
          
    
 
        <div
          style={{
            width: 154,
            height: 36,
            backgroundColor: "#574A69",
            borderRadius: 10,
            fontFamily: "inter, serif",
            fontSize: 14,
            color: "#fff",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: 'pointer',
            marginBottom: '20px'
          }}
          onClick={()=> setHide('flex')}
        >
         
          Nova Pendência
        </div>
        

        



 <div
          style={{
            width: 154,
            height: 36,
            backgroundColor: "#574A69",
            borderRadius: 10,
            fontFamily: "inter, serif",
            fontSize: 14,
            color: "#fff",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: 'pointer',
          }}
        
          onClick={()=> finalizarProjeto()}
        >
         
          Finalizar Projeto
        </div>



    </div>
      : 
      <a style={{color: 'rgb(119, 54, 54)'}}>Projeto Finalizado</a>
        }
      </div>
      <div
        style={{
          padding: "30px 10px",
          display: "flex",
          justifyContent: "space-between",
          borderBottom: "1px solid #F3F4F6",
          margin: "0px 10px",
          fontFamily: "Archivo, serif",
          fontWeight: 500,
          fontSize: 16,
          color: "#171A1F"
        }}
      >
        Filtros{" "}
        <a style={{ fontSize: 14, fontWeight: 400, color: "#574A69", cursor: 'pointer' }}
         onClick={()=> {limparFiltros(); setHide2('none')}}
        >
          Limpar Tudo
        </a>
      </div>
      <div
        style={{
          padding: "30px 10px",
          display: "flex",
          flexFlow: "column",
          justifyContent: "space-between",
          borderBottom: "1px solid #F3F4F6",
          margin: "0px 10px",
          fontFamily: "Archivo, serif",
          fontWeight: 500,
          fontSize: 16,
          color: "#171A1F"
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <a>Status</a>{" "}
          <a style={{ fontSize: 14, fontWeight: 400, color: "#574A69" }}>
            <i style={{ color: "black" }} className="bi bi-chevron-down" />
          </a>
        </div>
        <div
          style={{
            marginTop: 15,
            fontFamily: "Inter, serif",
            fontSize: 14,
            fontWeight: 400,
            display: "flex",
            flexFlow: "row nowrap",
            alignItems: "center"
          }}
        >
          <input
            style={{ width: 14, height: 14, marginRight: 5 }}
            type="checkbox"
            onClick={()=> filtrar()}
            className="checkb"
          />{" "}
          <a>Pendente</a>
        </div>
        <div
          style={{
            marginTop: 5,
            fontFamily: "Inter, serif",
            fontSize: 14,
            fontWeight: 400,
            display: "flex",
            flexFlow: "row nowrap",
            alignItems: "center"
          }}
        >
          <input
            style={{ width: 14, height: 14, marginRight: 5 }}
            type="checkbox"
            className="checkb"
            onChange={()=> filtrar()}
          />{" "}
          <a>Concluído</a>
        </div>
      </div>
      <div
        style={{
          padding: "30px 10px",
          display: "flex",
          flexFlow: "column",
          justifyContent: "space-between",
          borderBottom: "1px solid #F3F4F6",
          margin: "0px 10px",
          fontFamily: "Archivo, serif",
          fontWeight: 500,
          fontSize: 16,
          color: "#171A1F"
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <a>Responsável pela Solução</a>{" "}
          <a style={{ fontSize: 14, fontWeight: 400, color: "#574A69" }}>
            <i style={{ color: "black" }} className="bi bi-chevron-down" />
          </a>
        </div>




 {solucao.map((data, index)=> {

          return <>
                  <div
          style={{
            marginTop: '8px',
            fontFamily: "Inter, serif",
            fontSize: 14,
            fontWeight: 400,
            display: "flex",
            flexFlow: "row nowrap",
            alignItems: "center"
          }}
        >
          <div className="checkpoint">
          <input
            style={{ width: 14, height: 14, marginRight: 5 }}
            type="checkbox"
            
            onChange={()=> filtrar()}
          />{" "}
          <a>{
              data[0].split('#master')[3]
          }</a>
          </div>
        </div>
          
          
          </>
        })}







      </div>
      <div
        style={{
          padding: "30px 10px",
          display: "flex",
          flexFlow: "column",
          justifyContent: "space-between",
          borderBottom: "1px solid #F3F4F6",
          margin: "0px 10px",
          fontFamily: "Archivo, serif",
          fontWeight: 500,
          fontSize: 16,
          color: "#171A1F"
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <a>Requisitante</a>{" "}
          <a style={{ fontSize: 14, fontWeight: 400, color: "#574A69" }}>
            <i style={{ color: "black" }} className="bi bi-chevron-down" />
          </a>
        </div>






 {solucao.map((data, index)=> {

          return <>
                  <div
          style={{
            marginTop: '8px',
            fontFamily: "Inter, serif",
            fontSize: 14,
            fontWeight: 400,
            display: "flex",
            flexFlow: "row nowrap",
            alignItems: "center"
          }}
        >
          <div className="checkpoint2">
          <input
            style={{ width: 14, height: 14, marginRight: 5 }}
            type="checkbox"
            
            onChange={()=> filtrar()}
          />{" "}
          <a>{
              data[0].split('#master')[1].replaceAll('##', '')
          }</a>
          </div>
        </div>
          
          
          </>
        })}








      </div>
    </div>
  </div>
  <div className="col-9">
    <div>
      <div style={{ marginBottom: 40, display: 'flex' }}>
        <h2 className="meusProjetos">{nomeproj}</h2>
        <div className="botaofiltros" style={{ justifyContent: 'center', alignItems: 'center', 
          marginLeft: '20px', border: 'rgb(52, 52, 52) solid 1px', height: '40px', padding: '10px 20px',
          borderRadius: '10px', color: 'rgb(52, 52, 52)', cursor: 'pointer'}}
          onClick={()=> setHide2('flex')}
          >Filtros</div>
      </div>
      <div
        style={{ marginBottom: 50 }}
          className="botaofiltros"
      >
        <div style={{display: 'flex', flexFlow: 'column', justifyContent: 'start', alignItems: 'start'}}>


        <div
          className=""
          style={{
           
            display: "flex",
            flexFlow: "column",
            alignItems: "center",
            fontFamily: "Inter, serif",
            fontSize: 14,
            fontWeight: 400
          }}
        >
          <div style={{ display: "flex", flexFlow: "column" }}>
            Pendencias (Total)
            <a
              style={{
             
                fontFamily: "Archivo, serif",
                fontSize: 32,
                fontWeight: 600
              }}
            >
              {filtrados.length}
            </a>
          </div>
        </div>
        <div
     
          style={{

            display: "flex",
            flexFlow: "column",
            alignItems: "center",
            fontFamily: "Inter, serif",
            fontSize: 14,
            fontWeight: 400
          }}
        >
          <div style={{}}>
            <div style={{ display: "flex" }}>
              Prioridade:{" "}
              <div
                className="red"
                style={{
                  width: 45,
                  height: 24,
                  backgroundColor: "#FDF2F2",
                  borderRadius: 14,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  paddingRight: 5,
                  marginLeft: 5
                }}
              >
                <i
                  className="bi bi-arrow-up-short"
                  style={{ paddingBottom: 6, fontSize: 18 }}
                />
                <a style={{ paddingBottom: 2 }}>Alta </a>
              </div>{" "}
            </div>
            <a
              style={{
                marginTop: 15,
                fontFamily: "Archivo, serif",
                fontSize: 32,
                fontWeight: 600
              }}
            >
              {filtrados4.length}
            </a>
          </div>
        </div>
        <div

          style={{
  
            display: "flex",
            flexFlow: "column",
            alignItems: "center",
            fontFamily: "Inter, serif",
            fontSize: 14,
            fontWeight: 400
          }}
        >
          <div style={{ }}>
            <div style={{ display: "flex" }}>
              Prioridade:{" "}
              <div
                className="red"
                style={{
                  height: 24,
                  backgroundColor: "#FEF6F1",
                  borderRadius: 14,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: 71,
                  paddingRight: 5,
                  marginLeft: 5,
                  color: '#AE530D'
                }}
              >
                <i
                  className="bi bi-arrow-right-short"
                  style={{ paddingBottom: 6, fontSize: 18 }}
                />
                <a style={{ paddingBottom: 2 }}>Média </a>
              </div>{" "}
            </div>
            <a
              style={{
                marginTop: 15,
                fontFamily: "Archivo, serif",
                fontSize: 32,
                fontWeight: 600
              }}
            >
         {filtrados5.length}
            </a>
          </div>
        </div>
        <div
       
          style={{
            display: "flex",
            flexFlow: "column",
            alignItems: "center",
            fontFamily: "Inter, serif",
            fontSize: 14,
            fontWeight: 400
          }}
        >
          <div style={{  }}>
            <div style={{ display: "flex" }}>
              Prioridade:{" "}
              <div
                className="red"
                style={{
                  height: 24,
                  backgroundColor: "#F1F8FD",
                  borderRadius: 14,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: 70,
                  paddingRight: 5,
                  marginLeft: 5,
                  color: '#379AE6'
                }}
              >
                <i
                  className="bi bi-arrow-down-short"
                  style={{ paddingBottom: 6, fontSize: 18 }}
                />
                <a style={{ paddingBottom: 2 }}>Baixa </a>
              </div>{" "}
            </div>
            <a
              style={{
                marginTop: 15,
                fontFamily: "Archivo, serif",
                fontSize: 32,
                fontWeight: 600
              }}
            >
               {filtrados6.length}
            </a>
          </div>
        </div>
</div>
      </div>



   <div
        style={{ marginBottom: 50, marginLeft: "-30px" }}
        className=" row wrap flex-row responsivefiltro"
      >
        <div
          className="col-3 d-flex justify-content-center"
          style={{
            borderRight: "1px solid #BDC1CA",
            display: "flex",
            flexFlow: "column",
            alignItems: "center",
            fontFamily: "Inter, serif",
            fontSize: 14,
            fontWeight: 400
          }}
        >
          <div style={{ display: "flex", flexFlow: "column" }}>
            Pendencias (Total)
            <a
              style={{
                marginTop: 15,
                fontFamily: "Archivo, serif",
                fontSize: 32,
                fontWeight: 600
              }}
            >
              {filtrados.length}
            </a>
          </div>
        </div>
        <div
          className="col-3 d-flex justify-content-center"
          style={{
            borderRight: "1px solid #BDC1CA",
            display: "flex",
            flexFlow: "column",
            alignItems: "center",
            fontFamily: "Inter, serif",
            fontSize: 14,
            fontWeight: 400
          }}
        >
          <div style={{ display: "flex", flexFlow: "column" }}>
            <div style={{ display: "flex" }}>
              Prioridade:{" "}
              <div
                className="red"
                style={{
                  
                  height: 24,
                  backgroundColor: "#FDF2F2",
                  borderRadius: 14,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  paddingRight: 10,
                  paddingLeft: 4,
                  marginLeft: 5
                }}
              >
                <i
                  className="bi bi-arrow-up-short"
                  style={{ paddingBottom: 6, fontSize: 18 }}
                />
                <a style={{ paddingBottom: 2 }}>Alta </a>
              </div>{" "}
            </div>
            <a
              style={{
                marginTop: 15,
                fontFamily: "Archivo, serif",
                fontSize: 32,
                fontWeight: 600
              }}
            >
              {filtrados4.length}
            </a>
          </div>
        </div>
        <div
          className="col-3 d-flex justify-content-center"
          style={{
            borderRight: "1px solid #BDC1CA",
            display: "flex",
            flexFlow: "column",
            alignItems: "center",
            fontFamily: "Inter, serif",
            fontSize: 14,
            fontWeight: 400
          }}
        >
          <div style={{ display: "flex", flexFlow: "column" }}>
            <div style={{ display: "flex" }}>
              Prioridade:{" "}
              <div
                className="red"
                style={{
                  height: 24,
                  backgroundColor: "#FEF6F1",
                  borderRadius: 14,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: 71,
                  paddingRight: 5,
                  marginLeft: 5,
                  color: '#AE530D'
                }}
              >
                <i
                  className="bi bi-arrow-right-short"
                  style={{ paddingBottom: 6, fontSize: 18 }}
                />
                <a style={{ paddingBottom: 2 }}>Média </a>
              </div>{" "}
            </div>
            <a
              style={{
                marginTop: 15,
                fontFamily: "Archivo, serif",
                fontSize: 32,
                fontWeight: 600
              }}
            >
         {filtrados5.length}
            </a>
          </div>
        </div>
        <div
          className="col-3 d-flex justify-content-center"
          style={{
            display: "flex",
            flexFlow: "column",
            alignItems: "center",
            fontFamily: "Inter, serif",
            fontSize: 14,
            fontWeight: 400
          }}
        >
          <div style={{ display: "flex", flexFlow: "column" }}>
            <div style={{ display: "flex" }}>
              Prioridade:{" "}
              <div
                className="red"
                style={{
                  height: 24,
                  backgroundColor: "#F1F8FD",
                  borderRadius: 14,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: 70,
                  paddingRight: 5,
                  marginLeft: 5,
                  color: '#379AE6'
                }}
              >
                <i
                  className="bi bi-arrow-down-short"
                  style={{ paddingBottom: 6, fontSize: 18 }}
                />
                <a style={{ paddingBottom: 2 }}>Baixa </a>
              </div>{" "}
            </div>
            <a
              style={{
                marginTop: 15,
                fontFamily: "Archivo, serif",
                fontSize: 32,
                fontWeight: 600
              }}
            >
               {filtrados6.length}
            </a>
          </div>
        </div>
      </div>






      <div
        style={{
          display: "flex",
          flexFlow: "row nowrap",
          justifyContent: "space-between"
        }}
      >
        <div
          style={{
            fontFamily: "Archivo, serif",
            fontWeight: "bold",
            fontSize: 24
          }}
        >
          Pendências
        </div>
        <div className='responsivefiltro'>
        <div style={{ display: "flex", gap: 16 }}>
          <div
            style={{
             backgroundColor: `${corSim == true ?  "#FAEDFF"  :  "#F8F9FA"}`,
              width: 36,
              height: 36,
              borderRadius: 6,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: 'pointer'
            }}
            onClick={()=> {
              document.querySelector('.gridtriger').style.display = 'none';
              document.querySelector('.listatriger').style.display = 'block'; 
              setCorSim(true);           
            }}
          >
            <img style={{ width: 14, height: 13 }} src={listicon} />
          </div>
          <div
            style={{
              backgroundColor: `${corSim == true ? "#F8F9FA"  :  "#FAEDFF"}`,
              width: 36,
              height: 36,
              borderRadius: 6,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: 'pointer'
            }}
                        onClick={()=> {
              document.querySelector('.gridtriger').style.display = 'flex';
              document.querySelector('.listatriger').style.display = 'none';   
              setCorSim(false);         
            }}
          >
            <img style={{ width: 12, height: 15 }} src={gridicon} />
          </div>
        </div>
</div>



        
      </div>







<div className='listatriger'>





{filtrados.map((data, index)=> {

return <>


<div style={{ marginTop: 20 }} className='responsivefiltro'>
        {" "}
        {/* COL 12 SISTEM */}
        <div
          style={{
            border: "1px #DEE1E6 solid",
            borderRadius: 12,
            padding: 18,
            height: 168
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              height: 40
            }}
          >
            <div
              style={{
                display: "flex",
                flexFlow: "row nowrap",
                justifyContent: "center",
                alignContent: "center",
                fontFamily: "Convergence, serif",
                fontSize: 18
              }}
            >
              {data.nome}



              {data.prioridade[0].toUpperCase()+data.prioridade.slice(1,data.prioridade.length) == 'Baixa' &&
              
                  <div
                className="red"
                style={{
                  height: 24,
                  backgroundColor: "#F1F8FD",
                  borderRadius: 14,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  paddingLeft: 4,
                  paddingRight: 10,
                  marginLeft: 15,
                  color: "#379AE6"
                }}
              >
                <i
                  className="bi bi-arrow-down-short"
                  style={{ paddingBottom: 6, fontSize: 18 }}
                />
                <a style={{ paddingBottom: 2 }}>Baixa</a>
              </div>
              } 
          




      {data.prioridade[0].toUpperCase()+data.prioridade.slice(1,data.prioridade.length) == 'Media' &&
              
                  <div
                className="red"
                style={{
                  height: 24,
                  backgroundColor: "#FEF6F1",
                  borderRadius: 14,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  paddingLeft: 4,
                  paddingRight: 10,
                  marginLeft: 15,
                  color: "#AE530D"
                }}
              >
                <i
                  className="bi bi-arrow-right-short"
                  style={{ paddingBottom: 6, fontSize: 18 }}
                />
                <a style={{ paddingBottom: 2 }}>Média</a>
              </div>
              } 


     {data.prioridade[0].toUpperCase()+data.prioridade.slice(1,data.prioridade.length) == 'Alta' &&
              
                  <div
                className="red"
                style={{
                  height: 24,
                  backgroundColor: "#FDF2F2",
                  borderRadius: 14,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  paddingLeft: 4,
                  paddingRight: 10,
                  marginLeft: 15,
                  color: "#DE3B40"
                }}
              >
                <i
                  className="bi bi-arrow-up-short"
                  style={{ paddingBottom: 6, fontSize: 18 }}
                />
                <a style={{ paddingBottom: 2 }}>Alta</a>
              </div>
              } 









            </div>
            <div>
              <div
                style={{
                  display: "flex",
                  fontFamily: "Inter, serif",
                  fontSize: 12
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexFlow: "column",
                    justifyContent: "center"
                  }}
                >
                  {" "}
                  Status:
                </div>{" "}
                <div
                  className="red"
                  style={{
                    height: 24,
                    backgroundColor: `${data.status == 'Finalizado' ? "#EEFDF3" : "#FEF9EE"}`,
                    borderRadius: 14,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: 70,
                    paddingRight: 5,
                    marginLeft: 5
                  }}
                >
                  <a style={{ paddingBottom: 2, color: `${data.status == 'Finalizado' ? "#117B34" : "#98690C"}` }}>
                    {data.status}{" "}
                  </a>
                </div>{" "}
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              alignItems: "center",
              marginTop: 10
            }}
          >
            <div
              style={{
                height: 70,
                display: "flex",
                flexFlow: "column",
                textAlign: "center",
                justifyContent: "center",
                backgroundColor: "#F8F9FA",
                borderRadius: 6,
                padding: "0px 45px"
              }}
            >
              <a
                style={{
                  fontFamily: "Inter, serif",
                  fontSize: 14,
                  fontWeight: "bold"
                }}
              >
                {data.dataExpiracao != undefined && 
                <>
                     {data.dataExpiracao.slice(8,10)+'/'+data.dataExpiracao.slice(5,7)+'/'+data.dataExpiracao.slice(0,4)}
                </>
                }
           
              </a>
              <a style={{ fontFamily: "Inter, serif", fontSize: 12 }}>
                Prazo
              </a>
            </div>
            <div
              style={{
                height: 70,
                display: "flex",
                flexFlow: "column",
                textAlign: "center",
                justifyContent: "center",
                backgroundColor: "#F8F9FA",
                borderRadius: 6,
                padding: "0px 45px"
              }}
            >
              <a
                style={{
                  fontFamily: "Inter, serif",
                  fontSize: 14,
                  fontWeight: "bold"
                }}
              >
              
                {data.participantes.map((data, index)=> {
                  return <>
                  {data.split('###master')[3]} /
                  </>
                })}
              
              </a>
              <a style={{ fontFamily: "Inter, serif", fontSize: 12 }}>
                Responsável pela Solução
              </a>
            </div>
            <div
              style={{
                height: 70,
                display: "flex",
                flexFlow: "column",
                textAlign: "center",
                justifyContent: "center",
                backgroundColor: "#F8F9FA",
                borderRadius: 6,
                padding: "0px 45px"
              }}
            >
              <a
                style={{
                  fontFamily: "Inter, serif",
                  fontSize: 14,
                  fontWeight: "bold"
                }}
              >
                             {data.dataDeCriacao.slice(8,10)+'/'+data.dataDeCriacao.slice(5,7)+'/'+data.dataDeCriacao.slice(0,4) }

              </a>
              <a style={{ fontFamily: "Inter, serif", fontSize: 12 }}>
                Data de Criação
              </a>
            </div>
            <div
              style={{
                width: 154,
                height: 36,
                backgroundColor: "#574A69",
                borderRadius: 10,
                fontFamily: "inter, serif",
                fontSize: 14,
                color: "#fff",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: 'pointer'
              }}
              onClick={()=> navigate(`/PendenciaMaster?prjid=${parametroId}&ordem=${data.nome}&emaill=${current}`)}
            >
              <a style={{ fontSize: 14, fontWeight: 200, marginRight: 4 }}>
                <i className="bi bi-search" />{" "}
              </a>{" "}
              Ver Pendência
            </div>
          
          </div>
        </div>
      </div>





</>

})}


</div>


<div
  className="botaofiltros2 gridtriger"
  style={{ justifyContent: "flex-start", marginTop: 20 }}
>



{filtrados.map((data, index) => {
  return <>
  
  <div
    className="col-4"
    style={{
      border: "1px solid #DEE1E6",
      borderRadius: 10,
      paddingLeft: 20,
      width: 281
    }}
  >
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        paddingRight: 12,
        paddingTop: 10,
        fontFamily: "Inter, serif",
        fontSize: 12,
        color: "#565D6D"
      }}
    >
                {data.dataExpiracao != undefined && 
                <>
                     {data.dataDeCriacao.slice(8,10)+'/'+data.dataDeCriacao.slice(5,7)+'/'+data.dataDeCriacao.slice(0,4)}
                </>
                }
    </div>
    <div
      style={{
        fontFamily: "Convergence, serif",
        fontSize: 18,
        color: "#171A1F",
        marginTop: 10
      }}
    >
       {data.nome}
    </div>
    <div style={{ display: "flex", flexFlow: "column", marginTop: 15 }}>
      <a style={{ fontFamily: "Inter, serif", fontSize: 11 }}>Prazo</a>
      <a
        style={{ fontFamily: "Inter, serif", fontSize: 14, fontWeight: "bold" }}
      >
        {data.dataExpiracao != undefined && 
                <>
                     {data.dataExpiracao.slice(8,10)+'/'+data.dataExpiracao.slice(5,7)+'/'+data.dataExpiracao.slice(0,4)}
                </>
                }
      </a>
    </div>
    <div style={{ display: "flex", flexFlow: "column", marginTop: 15 }}>
      <a style={{ fontFamily: "Inter, serif", fontSize: 11 }}>
        Responsável pela solução:
      </a>
      <a
        style={{ fontFamily: "Inter, serif", fontSize: 14, fontWeight: "bold" }}
      >
            {data.participantes.map((data, index)=> {
                  return <>
                  {data.split('###master')[3]} /
                  </>
                })}
      </a>
    </div>
    <div style={{ display: "flex", marginTop: 15 }}>
      <div
        className="red"
        style={{
          height: 28,
          backgroundColor: `${data.status == 'Finalizado' ? "#EEFDF3" : "#FEF9EE"}`,
          borderRadius: 14,
          display: "flex",
          color: `${data.status == 'Finalizado' ? "#117B34" : "#98690C"}`,
          justifyContent: "center",
          alignItems: "center",
          paddingLeft: 10,
          paddingRight: 10,
          fontSize: 13
        }}
      >
        <a style={{ paddingBottom: 2 }}>{data.status == 'Finalizado' ? "Finalizado" : "Pendente"} </a>
      </div>
  



        {data.prioridade[0].toUpperCase()+data.prioridade.slice(1,data.prioridade.length) == 'Baixa' &&
              
      <div
        className="red"
        style={{
          height: 28,
         backgroundColor: "#F1F8FD",
          borderRadius: 14,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          paddingLeft: 5,
          paddingRight: 10,
          marginLeft: 10,
      color: "#379AE6",
          fontSize: 12
        }}
      >
        <i
          className="bi bi-arrow-down-short"
          style={{ paddingBottom: 6, fontSize: 18 }}
        />
        <a style={{ paddingBottom: 2 }}>Baixa </a>
      </div>

      } 
          

      {data.prioridade[0].toUpperCase()+data.prioridade.slice(1,data.prioridade.length) == 'Media' &&
              

<div
        className="red"
        style={{
          height: 28,
        backgroundColor: "#FEF6F1",
          borderRadius: 14,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          paddingLeft: 5,
          paddingRight: 10,
          marginLeft: 10,
      color: "#AE530D",
          fontSize: 12
        }}
      >
        <i
          className="bi bi-arrow-up-short"
          style={{ paddingBottom: 6, fontSize: 18 }}
        />
        <a style={{ paddingBottom: 2 }}>Média </a>
      </div>



              } 


     {data.prioridade[0].toUpperCase()+data.prioridade.slice(1,data.prioridade.length) == 'Alta' &&
              


<div
        className="red"
        style={{
          height: 28,
          backgroundColor: "#FDF2F2",
          borderRadius: 14,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          paddingLeft: 5,
          paddingRight: 10,
          marginLeft: 10,
          color: "#DE3B40",
          fontSize: 12
        }}
      >
        <i
          className="bi bi-arrow-up-short"
          style={{ paddingBottom: 6, fontSize: 18 }}
        />
        <a style={{ paddingBottom: 2 }}>Alta </a>
      </div>


              } 












    </div>
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        marginTop: 26,
        marginBottom: 26
      }}
    >
      <div
        style={{
          width: 112,
          height: 32,
          backgroundColor: "#574A69",
          borderRadius: 10,
          fontFamily: "inter, serif",
          fontSize: 12,
          color: "#fff",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: 'pointer'
        }}
        onClick={()=> navigate(`/PendenciaMaster?prjid=${parametroId}&ordem=${data.nome}&emaill=${current}`)}
      >
        Ver Pendência
      </div>
    
    </div>
  </div>
  </>
})}





</div>









    </div>
  </div>
</div>







        </div>
        
        <Rodape/>
        
        </>
    )
}
export default OrdensDeServico;